type SpinnerProps = {
  className?: string;
};

export default function Spinner({ className }: SpinnerProps) {
  return (
    <div
      className={`size-8 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent ${className ?? ''}`}
    />
  );
}
